const FEATURES_DATA = [
  {
    icon: 'ri-4k-line',
    title: '1080P高清画质',
    desc: '全站电视剧全集完整剧集支持1080P高清画质，清晰锐利的画面让每一个场景细节尽收眼底。智能码率调节技术，在网络波动时自动优化画质，确保播放流畅不卡顿。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速缓冲播放',
    desc: '采用全球CDN加速网络与智能预加载技术，点击即播无需等待。热门剧集提前缓存至离你最近的节点，无论是国产剧还是海外剧都能享受秒开的流畅追剧体验。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量剧集资源',
    desc: '收录超过10,000部电视剧全集完整剧集，从经典老剧到最新热播，从国产剧到海外剧全季资源应有尽有。每日持续更新，追剧不再等待，好剧一网打尽。',
  },
];

const TOPICS_DATA = [
  { tag: '#长安风云录大结局', heat: '986万讨论' },
  { tag: '#暗夜追踪真凶揭晓', heat: '754万讨论' },
  { tag: '#都市夜归人CP', heat: '632万讨论' },
  { tag: '#遇见你的季节名场面', heat: '521万讨论' },
  { tag: '#家的方向催泪', heat: '489万讨论' },
  { tag: '#古装剧文艺复兴', heat: '412万讨论' },
  { tag: '#悬疑剧高能反转', heat: '378万讨论' },
  { tag: '#国产剧出海', heat: '345万讨论' },
  { tag: '#追剧人的快乐', heat: '298万讨论' },
  { tag: '#全集免费看', heat: '267万讨论' },
];

const UPDATES_DATA = [
  { date: '07-31', title: '《暗夜追踪》大结局上线，全36集完整版已收录', tag: '大结局' },
  { date: '07-30', title: '新剧《星辰大海》前8集更新，职场励志题材', tag: '新剧' },
  { date: '07-30', title: '《长安风云录》海外版字幕优化完成', tag: '更新' },
  { date: '07-29', title: '韩剧《逆光之恋》全16集中文字幕版上线', tag: '海外' },
  { date: '07-28', title: '《家的方向》收视破纪录，全48集热度飙升', tag: '热门' },
  { date: '07-27', title: '日剧《深夜食堂第五季》全10集独家上线', tag: '海外' },
  { date: '07-26', title: '《遇见你的季节》豆瓣9.2分，口碑持续走高', tag: '口碑' },
  { date: '07-25', title: '平台新增悬疑剧场专题，189部好剧一键直达', tag: '专题' },
];

const RANKING_DATA = [
  { rank: 1, title: '长安风云录', score: '9.5', heat: '1280万', change: 'up' },
  { rank: 2, title: '暗夜追踪', score: '9.4', heat: '1156万', change: 'up' },
  { rank: 3, title: '家的方向', score: '9.3', heat: '987万', change: 'same' },
  { rank: 4, title: '都市夜归人', score: '9.2', heat: '865万', change: 'up' },
  { rank: 5, title: '遇见你的季节', score: '9.1', heat: '743万', change: 'down' },
  { rank: 6, title: '逆光之恋', score: '8.9', heat: '621万', change: 'new' },
];

const CAROUSEL_DATA = [
  {
    title: '古装巨制 · 盛世华章',
    desc: '从宫廷权谋到江湖侠义，精选百部高分古装剧，全季完整版一键畅享。大唐风华、大宋雅韵、大明气度，穿越千年与你相遇。',
    tag: '古装剧场',
    img: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20banner%20for%20historical%20epic%20drama%20collection%2C%20ancient%20Chinese%20palace%20architecture%20at%20golden%20hour%2C%20sweeping%20panoramic%20view%20with%20warm%20orange%20and%20amber%20sky%2C%20dramatic%20clouds%2C%20epic%20scale%20composition%2C%20rich%20warm%20tones%2C%20cinematic%20widescreen%20aesthetic&width=800&height=500&seq=carousel-feature-01&orientation=landscape',
    imgAlt: '古装巨制盛世华章专题',
  },
  {
    title: '都市剧场 · 百味人生',
    desc: '职场拼搏、甜蜜爱情、温暖家庭——都市生活中的每一个动人故事都在这里。全季高清追剧，感受属于这个时代的温度与力量。',
    tag: '都市剧场',
    img: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20banner%20for%20modern%20urban%20drama%20collection%2C%20futuristic%20city%20skyline%20at%20twilight%20with%20warm%20ambient%20city%20lights%2C%20sleek%20modern%20architecture%2C%20golden%20and%20rose%20gold%20tones%2C%20epic%20scale%20composition%2C%20cinematic%20widescreen%20aesthetic&width=800&height=500&seq=carousel-feature-02&orientation=landscape',
    imgAlt: '都市剧场百味人生专题',
  },
  {
    title: '悬疑剧场 · 烧脑盛宴',
    desc: '刑侦探案、心理悬疑、谍战风云——高能反转不断的高分悬疑剧合集。每一部都让你欲罢不能，全集完整版一口气追到大结局。',
    tag: '悬疑剧场',
    img: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20banner%20for%20suspense%20thriller%20collection%2C%20dramatic%20noir%20cityscape%20at%20night%20with%20warm%20amber%20street%20lights%2C%20moody%20atmospheric%20fog%2C%20mysterious%20ambiance%2C%20rich%20dark%20tones%20with%20golden%20highlights%2C%20cinematic%20widescreen%20aesthetic&width=800&height=500&seq=carousel-feature-03&orientation=landscape',
    imgAlt: '悬疑剧场烧脑盛宴专题',
  },
  {
    title: '甜宠剧场 · 心动瞬间',
    desc: '从校园初恋到都市浪漫，精选高甜爱情剧让你心跳加速。全集免费在线观看，每一帧都是名场面，每一个故事都值得被珍藏。',
    tag: '甜宠剧场',
    img: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20banner%20for%20romantic%20drama%20collection%2C%20dreamy%20sunset%20landscape%20with%20rolling%20hills%20and%20warm%20golden%20light%2C%20soft%20atmospheric%20clouds%2C%20romantic%20warm%20peach%20and%20amber%20tones%2C%20cinematic%20widescreen%20aesthetic&width=800&height=500&seq=carousel-feature-04&orientation=landscape',
    imgAlt: '甜宠剧场心动瞬间专题',
  },
  {
    title: '海外精选 · 全球好剧',
    desc: '美剧、韩剧、日剧、泰剧——415部海外高分剧集全季收录，专业中文字幕让你无障碍追剧。同步更新热门海外剧，世界好剧触手可及。',
    tag: '海外精选',
    img: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20banner%20for%20international%20drama%20collection%2C%20world%20map%20with%20warm%20golden%20glowing%20connections%20between%20continents%2C%20diverse%20cultural%20landmarks%20in%20soft%20ambient%20light%2C%20global%20cinema%20theme%2C%20cinematic%20widescreen%20aesthetic%2C%20warm%20inviting%20tones&width=800&height=500&seq=carousel-feature-05&orientation=landscape',
    imgAlt: '海外精选全球好剧专题',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          特色亮点
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          为什么数百万剧迷选择桔子影院
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {FEATURES_DATA.map((feature) => (
            <div key={feature.title} className="text-center group">
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3 whitespace-nowrap">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          追剧圈最热讨论，看看大家都在聊什么
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS_DATA.map((topic) => (
            <div
              key={topic.tag}
              className="group bg-background-50 rounded-full px-5 py-2.5 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer flex items-center gap-2"
            >
              <h3 className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                {topic.tag}
              </h3>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          追剧快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          最新剧集动态，第一时间掌握
        </p>
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-4">
            {UPDATES_DATA.map((item, i) => (
              <div key={i} className="flex gap-4 items-start">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 relative z-10">
                  <div className={`w-[38px] h-[38px] rounded-full flex items-center justify-center ${
                    i === 0 ? 'bg-primary-500' : 'bg-background-200'
                  }`}>
                    <span className={`text-xs font-bold ${i === 0 ? 'text-background-50' : 'text-foreground-600'}`}>
                      {item.date}
                    </span>
                  </div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/70 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="sm:hidden text-xs font-bold text-primary-600">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.tag === '大结局' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '新剧' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '海外' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm text-foreground-800 leading-relaxed">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          热播榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          本周最受欢迎剧集排行榜
        </p>
        <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60">
          {RANKING_DATA.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                i < RANKING_DATA.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              {/* Rank */}
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500' :
                item.rank === 2 ? 'bg-accent-500' :
                item.rank === 3 ? 'bg-secondary-500' :
                'bg-background-200'
              }`}>
                <span className={`text-sm font-bold ${
                  item.rank <= 3 ? 'text-background-50' : 'text-foreground-600'
                }`}>
                  {item.rank}
                </span>
              </div>

              {/* Title */}
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                  {item.title}
                </h3>
              </div>

              {/* Score */}
              <div className="text-right flex-shrink-0">
                <div className="text-sm font-bold text-primary-600 whitespace-nowrap">{item.score}</div>
                <div className="text-xs text-foreground-400">{item.heat}热度</div>
              </div>

              {/* Change indicator */}
              <div className="flex-shrink-0 w-6 text-center">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.change === 'new' && <span className="text-xs text-accent-500 font-bold">NEW</span>}
                {item.change === 'same' && <span className="text-xs text-foreground-300">—</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          编辑精选专题，发现更多好剧
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_DATA.map((item) => (
            <article key={item.title} className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative overflow-hidden aspect-[16/10] bg-background-200">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center text-primary-600 text-sm font-medium">
                  <span className="whitespace-nowrap">探索专题</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:ml-2 transition-all"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}